import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedCitySelector } from 'selectors/app-selector';
import GeoDuck from 'ducks/geo-duck';

const SuggestPOIListener = () => {
  const dispatch = useDispatch();
  const city = useSelector(selectedCitySelector);

  useEffect(
    () => {
      if (!city) {
        return;
      }
      dispatch(GeoDuck.creators.fetchSuggestPOIs('dropoff'));
    },
    [city],
  );
  return <div />;
};

export default SuggestPOIListener;
